import styled from 'styled-components';

export const ProfileInfoCardContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
    background: var(--color-background-secondary);
    padding: 16px;
    width: 100%;
    border-radius: 16px;
    flex-direction: column;
    box-shadow: var(--shadow-primary);

    svg {
        fill: var(--color-label-secondary);
    }
`;

export const ProfileInfoCardRowStyled = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ProfileInfoCardColumnStyled = styled.div`
    display: flex;
    flex-direction: column;
`;


export const ProfileInfoCardTitleStyled = styled.h4`
    font-weight: 400;
    font-size: 16px;
    color: var(--color-label-primary);
   
`;

export const ProfileInfoCardTextStyled = styled.div`
    color: var(--color-label-secondary);
    font-size: 12px;
    font-weight: 400;
`;

export const ProfileInfoCardStyled = {
    Container: ProfileInfoCardContainerStyled,
    Title: ProfileInfoCardTitleStyled,
    Row: ProfileInfoCardRowStyled,
    Column: ProfileInfoCardColumnStyled,
    Text: ProfileInfoCardTextStyled
}